import { colors } from "theme/palette";

import Box from "components/Box";
import Stack from "components/Stack";
import Text from "components/Text";

import BoxImage from "./assets/image.svg";

const ExplanatoryBox = () => (
  <Box
    sx={{
      paddingLeft: 2,
      paddingRight: 5,
      paddingY: 3,
      borderRadius: "4px",
      maxWidth: "700px;",
      backgroundColor: colors.blue10,
    }}
  >
    <Stack spacing={2} direction="row">
      <img src={BoxImage} alt="" />

      <Stack>
        <Text variant="text2" fontWeight={700}>
          Bring in any data from your file with cell range sync
        </Text>

        <Text variant="text4" marginTop={0.5}>
          Using an already uploaded source file (Excel), you can create any
          number of tables by selecting the exact cell range (select from which
          sheet, and which rows & columns) you want to bring in. The values
          within the selected cell range will be displayed here automatically.
          You can name your table, and every time you re-upload the source file,
          the values will sync in case they got updated.
        </Text>
      </Stack>
    </Stack>
  </Box>
);

export default ExplanatoryBox;
